import React from "react"

import './style.css';

const small = props => {
  return <div className="skeleton-container">
    <div className="line sm h60"></div>
  </div>
}

export default small;
